<div>
  <h2>{{'usuarios.general.titulo' | translate}}</h2>
  <section class="filters-framed" *ngIf="filtersVisible">
    <form [formGroup]="filtersForm" [ngClass]="{'show-error':showError}">
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'usuarios.general.filters.rol' | translate}}</label>
        <app-filterable-list [itemsList]="rolesUsuarios" [selectedItem]="filtersForm.get('rol')" [placeHolder]="false">
        </app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'usuarios.general.filters.userName' | translate}}</label>
        <input type="text" formControlName="nombreUsuario">
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'usuarios.general.filters.email' | translate}}</label>
        <input type="text" formControlName="email">
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'usuarios.general.filters.idioma' | translate}}</label>
        <app-filterable-list [itemsList]="idiomas" [selectedItem]="filtersForm.get('idioma')" [placeHolder]="false">
        </app-filterable-list>
      </div>
      <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <checkbox [id]="'habilitado'" [initialStatus]="'true'" [initialRefresh]="refreshCheckbox_habilitado" [label]="'usuarios.general.filters.habilitado'"
          (refresh)="this.refreshCheckbox_habilitado = false" (formValue)="this.filtersForm.get('habilitado').patchValue($event)" (pristine)="pristineCheckbox('habilitado', $event)"></checkbox>
      </div>
      <div *ngIf="this.isSmallScreen" class="entry-3-small"></div>
    </form>
  </section>
  <section class="filters-buttons">
    <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}" (click)="filtersVisible=!filtersVisible"
      title="{{'global.filtros.abrir' | translate}}">
      <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
    </button>
    <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
      (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
      <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
    </button>
    <button *ngIf="filtersVisible" class="secondary"
      [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
      title="{{'global.filtros.limpiar' | translate}}">
      <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
    </button>
    <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
      title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
      <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
    </button>
  </section>
  <div class="table-wrapper">
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th class="icon"></th>
            <th class="icon"></th>
            <th class="string sortable" (click)="toOrderBy('x=> x.ApplicationUserRoles.FirstOrDefault().ApplicationRole.Name', 3)">
              {{'usuarios.general.table.rol' | translate}}
              <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.ApplicationUserRoles.FirstOrDefault().ApplicationRole.Name')"></i></div>
            </th>
            <th class="string sortable" (click)="toOrderBy('x=> x.UserName', 4)">
              {{'usuarios.general.table.userName' | translate}}
              <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.UserName')"></i></div>
            </th>
            <th class="string sortable" (click)="toOrderBy('x=> x.PhoneNumber', 5)">
              {{'usuarios.general.table.telefono' | translate}}
              <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.PhoneNumber')"></i></div>
            </th>
            <th class="string sortable" (click)="toOrderBy('x=> x.UserName', 6)">
              {{'usuarios.general.table.email' | translate}}
              <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.UserName')"></i></div>
            </th>
            <th class="date sortable" (click)="toOrderBy('x=> x.FechaIns', 7)">
              {{'global.fecha.insercionShort' | translate}}
              <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.FechaIns')"></i></div>
            </th>
            <th class="date sortable" (click)="toOrderBy('x=> x.FechaUpd', 8)">
              {{'global.fecha.actualizacionShort' | translate}}
              <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.FechaUpd')"></i></div>
            </th>
            <th class="action">
              <i class="fas fa-plus" *ngIf="this.role === 'Administrador'" (click)="create()" title="{{'usuarios.general.tituloNew' | translate}}"></i>
            </th>
          </tr>
        </thead>
        <tbody class="clickable" *ngFor="let usuario of usuarios; let i=index; trackBy: trackByUsuarioId">
          <tr (click)="showDetails(i);" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
            <td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                title="{{dropdownInfo === i ? 'Minimizar Info' : '+Info'}}"></i>
            </td>
            <td class="multi-icon">
              <i class="fas fa-sm fa-user-lock" *ngIf="!usuario.activo" title="{{'titles.usuarioDesactivado' | translate}}"></i>
            </td>
            <td class="string">{{usuario.strRoleName}}</td>
            <td class="string-overflow" title="{{usuario.userName}}">{{usuario.userName}}</td>
            <td class="string">{{usuario.phoneNumber}}</td>
            <td class="string-overflow" title="{{usuario.email}}">{{usuario.email}}</td>
            <td class="date">{{usuario.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
            <td class="date">{{usuario.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
            <td class="multi-actions">
              <i class="fas fa-users-gear"  title="{{'usuarios.general.modalDeleteRole.titulo' | translate}}" *ngIf="this.role === 'Administrador'" app-click-stop-propagation (click)="openDeleteRole(usuario)" [ngClass]="{'disabled': usuario.roles.length <= 1}"></i>
              <i class='fas fas fa-pencil-alt' title="{{'global.actualizar' | translate}}" *ngIf="this.role === 'Administrador'" app-click-stop-propagation (click)="update(usuario)"></i>
              <i class="fas fa-sync-alt"  title="{{'usuarios.general.resetPassword' | translate}}" *ngIf="this.role === 'Administrador'" app-click-stop-propagation (click)="openConfirm(usuario)"></i>
            </td>
          </tr>
          <tr *ngIf="dropdownInfo === i">
            <td colspan="9">
              <div class="detail">
                <div class="title">{{'global.masInformacion' | translate}}</div>
                <div class="block-inline">
                  <label>{{'usuarios.general.table.details.bloqueo' | translate}}<i class="fas fa-info-circle"
                      title="{{'usuarios.general.infoBloqueo' | translate}}" style="margin-left: .15rem"></i></label>
                  <p>
                    {{usuario.lockoutEnabled ?  ('global.activado' | translate) : ('global.desactivado' | translate)}}
                  </p>
                </div>
                <div class="block-inline">
                  <label>{{'usuarios.general.table.details.fechaBloqueo' | translate}}</label>
                  <p>
                    {{usuario.lockoutEnd ?  (usuario.lockoutEnd | date: 'short' : undefined : defaultLanguage) : ('global.fecha.sinFecha' | translate)}}
                  </p>
                </div>
                <div class="block-inline">
                  <label>{{'usuarios.general.table.details.dosFactores' | translate}}</label>
                  <p>
                    {{usuario.twoFactorEnabled ?  ('global.activado' | translate) : ('global.desactivado' | translate)}}
                  </p>
                </div>
                <div class="block-inline">
                  <label>{{'usuarios.general.table.details.idioma' | translate}}</label>
                  <p>
                    {{usuario.desIdioma}}
                  </p>
                </div>
                <!-- 11/01/2023
                <table>
                  <thead>
                    <tr>
                      <th class="string">{{'usuarios.general.table.details.rol' | translate}}</th>
                      <th class="string">{{'usuarios.general.table.details.permisos' | translate}} ({{usuario.availableClaims[0].availableClaims.length}})</th>
                    </tr>
                  </thead>
                  <tbody *ngFor="let claim of usuario.availableClaims[0].availableClaims">
                    <tr>
                      <td class="string">{{usuario.availableClaims[0].roleName}}</td>
                      <td class="string">{{claim}}</td>
                    </tr>
                  </tbody>
                  <tfoot
                    *ngIf="!usuario.availableClaims || (usuario.availableClaims && usuario.availableClaims.length < 1)">
                    <tr>
                      <td colspan="2">
                        {{'global.noContent' | translate}}
                      </td>
                    </tr>
                  </tfoot>
                </table>-->
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot *ngIf="!usuarios || (usuarios && usuarios.length < 1)">
          <tr>
            <td colspan="6">
              {{'global.noContent' | translate}}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
  <app-paginator *ngIf="usuarios && usuarios.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
    [totalItems]="totalItems" [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
    (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
  <app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event">
  </app-toast>
</div>
<div class="modal" *ngIf="newEditModal">
  <div class="modal-content">
    <header>
      <h4>{{usuarioId ? ('usuarios.general.tituloEdit' | translate) : ('usuarios.general.tituloNew' | translate)}}</h4>
    </header>
    <app-usr-new-edit [usuarioId]="usuarioId" (refreshData)="refreshData($event)" (mensaje)="pushMessage($event)">
    </app-usr-new-edit>
  </div>
</div>
<div class="modal" *ngIf="confirmModal">
  <div class="modal-content">
    <header>
      <h4>{{'usuarios.general.resetPassword' | translate}}</h4>
    </header>
    <content>
      <button (click)="resetPassword()">{{'usuarios.general.resetPassword' | translate}}</button>
      <button (click)="closeConfirm()">{{'global.cancelar' | translate}}</button>
    </content>
  </div>
</div>
<div class="modal" *ngIf="deleteRoleModal">
  <div class="modal-content">
    <header>
      <h4>{{'usuarios.general.modalDeleteRole.titulo' | translate}}</h4>
    </header>
    <app-delete-role [userName]="userName" [userRoles]="userRoles" (refreshRoles)="refreshUserRoles($event)"  (mensaje)="pushMessage($event)">
    </app-delete-role>
  </div>
</div>
